import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumReducer(state = initialState.verumstorage, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMSTORAGE_SUCCESS:
      return action.verumstorage;

    default:
      return state;
  }
}
